import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import { Delete } from '@material-ui/icons';
import dotProp from 'dot-prop-immutable';
import axiosUI from '../../axiosUI';
import Button from '../Button/Button';
import PopupWrapper from '../PopupWrapper';
import {
  CHANNEL_VARIANTS,
  RESOURCE_STATES,
  OPERATION_TYPES,
} from '../../constants';
const { UNSAVED, DRAFT, PUBLISHED } = RESOURCE_STATES;
const { OFFICIAL} = CHANNEL_VARIANTS;

class ChannelDelete extends Component {
  static propTypes = {
    channel: PropTypes.object,
    currentVariant: PropTypes.string.isRequired,
    selectedChannelType: PropTypes.string.isRequired,
    updateParentState: PropTypes.func.isRequired,
    transformChannelDataComingFromBackend: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      showDeleteWarningPopup: false,
    };
  }

  deleteChannel = async () => {
    const {
      channel,
      currentVariant,
      channelIndex,
      selectedChannelType,
      currentChannelTypeList,
    } = this.props;

    const variantState = channel[currentVariant].state;

    if (currentVariant === OFFICIAL) {
      switch (variantState) {
        case UNSAVED: {
          // delete both variants
          const updatedChannelTypeList = dotProp.delete(
            currentChannelTypeList,
            channelIndex
          );
          this.props.updateParentState({
            [selectedChannelType]: updatedChannelTypeList,
          });
          break;
        }
        case DRAFT: {
          const discardDraftUrl = '/api/channels';
          try {
            await axiosUI.delete(discardDraftUrl, {
              data: [{ id: channel.id, variant: currentVariant }],
            });
            const publishedOfficalVariantForDeletedDraft = this.props.apiData.find(
              item => {
                return (
                  item.id === channel.id &&
                  channel.variant === currentVariant &&
                  channel.state === PUBLISHED
                );
              }
            );
            if (publishedOfficalVariantForDeletedDraft) {
              // replace discarded draft with published version
              const publishedChannel = this.props.transformChannelDataComingFromBackend(
                publishedOfficalVariantForDeletedDraft
              );
              const {
                id,
                name,
                type,
                locale,
                sales_channel_id,
                ...variantSpecificField
              } = publishedChannel;
              const updatedChannelTypeList = dotProp.set(
                currentChannelTypeList,
                `${channelIndex}.${currentVariant}`,
                variantSpecificField
              );
              this.props.updateParentState({
                [selectedChannelType]: updatedChannelTypeList,
              });
            } else {
              // delete both variants
              const updatedChannelTypeList = dotProp.delete(
                currentChannelTypeList,
                channelIndex
              );
              this.props.updateParentState({
                [selectedChannelType]: updatedChannelTypeList,
              });
            }
          } catch (err) {
            console.log(err);
          }
          break;
        }
        case PUBLISHED: {
          const updatedChannel = {
            ...channel,
            [CHANNEL_VARIANTS[currentVariant]]: {
              ...channel[CHANNEL_VARIANTS[currentVariant]],
              operation_type: OPERATION_TYPES.DELETE,
              state: UNSAVED,
            },
          };
          const updatedChannelTypeList = dotProp.set(
            currentChannelTypeList,
            channelIndex,
            updatedChannel
          );
          this.props.updateParentState({
            [selectedChannelType]: updatedChannelTypeList,
          });
          break;
        }
        default:
          break;
      }
    } else {
      switch (variantState) {
        case UNSAVED: {
          // delete override variant and switch to OFFICIAL
          const updatedChannelTypeList = dotProp.delete(
            currentChannelTypeList,
            `${channelIndex}.${currentVariant}`
          );
          this.props.updateParentState({
            [selectedChannelType]: updatedChannelTypeList,
            currentVariant: OFFICIAL,
          });
          break;
        }
        case DRAFT: {
          const discardDraftUrl = '/api/channels';
          try {
            await axiosUI.delete(discardDraftUrl, {
              data: [{ id: channel.id, variant: currentVariant }],
            });
            const publishedOverrideVariantForDeletedDraft = this.props.apiData.find(
              item => {
                return (
                  item.id === channel.id &&
                  channel.variant === currentVariant &&
                  channel.state === PUBLISHED
                );
              }
            );
            if (publishedOverrideVariantForDeletedDraft) {
              // replace discarded draft with published version
              const publishedChannel = this.props.transformChannelDataComingFromBackend(
                publishedOverrideVariantForDeletedDraft
              );
              const {
                id,
                name,
                type,
                locale,
                sales_channel_id,
                ...variantSpecificField
              } = publishedChannel;
              const updatedChannelTypeList = dotProp.set(
                currentChannelTypeList,
                `${channelIndex}.${currentVariant}`,
                variantSpecificField
              );
              this.props.updateParentState({
                [selectedChannelType]: updatedChannelTypeList,
              });
            } else {
              // delete override variant and switch to OFFICIAL
              const updatedChannelTypeList = dotProp.delete(
                currentChannelTypeList,
                `${channelIndex}.${currentVariant}`
              );
              this.props.updateParentState({
                [selectedChannelType]: updatedChannelTypeList,
                currentVariant: OFFICIAL,
              });
            }
          } catch (err) {
            console.log(err);
          }
          break;
        }
        case PUBLISHED: {
          const updatedChannel = {
            ...channel,
            [CHANNEL_VARIANTS[currentVariant]]: {
              ...channel[CHANNEL_VARIANTS[currentVariant]],
              operation_type: OPERATION_TYPES.DELETE,
              state: UNSAVED,
            },
          };
          const updatedChannelTypeList = dotProp.set(
            currentChannelTypeList,
            channelIndex,
            updatedChannel
          );
          this.props.updateParentState({
            [selectedChannelType]: updatedChannelTypeList,
          });
          break;
        }
        default:
          break;
      }
    }

    // close popup if it's open
    if (this.state.showDeleteWarningPopup) {
      this.toggleDeleteWarningPopup();
    }
  };

  deleteButtonHandler = () => {
    const { channel, currentVariant } = this.props;

    // if official
    // -> warn user if variant is in DRAFT of PUBLISHED state
    // -> otherwise trigger deleteChannel method

    // if override
    // -> warn user if variant is in DRAFT
    // -> otherwise trigger deleteChannel method

    const variantData = channel[currentVariant];
    if (currentVariant === OFFICIAL) {
      if (variantData.state !== UNSAVED) {
        this.setState({ showDeleteWarningPopup: true });
      } else {
        this.deleteChannel();
      }
    } else {
      if (variantData.state === DRAFT) {
        this.setState({ showDeleteWarningPopup: true });
      } else {
        this.deleteChannel();
      }
    }
  };

  getWarningPopupText = () => {
    const { channel, currentVariant } = this.props;
    const variantData = channel[currentVariant];

    if (variantData.state === DRAFT) {
      return {
        content: 'Are you sure you want to discard this draft?',
        noButton: 'No',
        yesButton: 'Yes, discard it',
      };
    }

    // else is -> PUBLISHED OFFICIAL case
    return {
      content:
        'Are you sure you want to delete DEFAULT config? Deleting this will also delete your OVERRIDE config',
      noButton: 'No',
      yesButton: 'Yes, delete it',
    };
  };

  toggleDeleteWarningPopup = () => {
    this.setState(prevState => {
      return {
        showDeleteWarningPopup: !prevState.showDeleteWarningPopup,
      };
    });
  };

  render() {
    const { showDeleteWarningPopup } = this.state;
    const warningPopupText = this.getWarningPopupText();
    return (
      <PopupWrapper
        className="relative h-6"
        isOpen={showDeleteWarningPopup}
        togglePopup={this.toggleDeleteWarningPopup}>
        <Button
          onClick={this.deleteButtonHandler}
          type="transparent"
          className="p-0-important shadow-none-important ml-4 h-6">
          <Delete className="text-darkGrey" />
        </Button>
        <AnimatePresence>
          {showDeleteWarningPopup && (
            <motion.div
              initial={{ opacity: 0, x: '-70%', y: '0%' }}
              animate={{ opacity: 1, x: '-95%' }}
              exit={{ opacity: 0, x: '-70%' }}
              transition={{
                ease: [0.18, 0.89, 0.39, 1.4],
                duration: 0.3,
              }}
              className="absolute pin-t pin-l px-2 py-4 bg-white shadow-lg rounded text-left w-64">
              <div className="text-center leading-normal">
                {warningPopupText.content}
              </div>
              <div className="flex justify-around mt-8">
                <Button className="h-8" onClick={this.toggleDeleteWarningPopup}>
                  {warningPopupText.noButton}
                </Button>
                <Button
                  type="red-transparent"
                  className="h-8"
                  onClick={this.deleteChannel}>
                  {warningPopupText.yesButton}
                </Button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </PopupWrapper>
    );
  }
}

export default  ChannelDelete;
